import { atom } from 'jotai';

type V2MigrationInitFlowStatus = 'hidden' | 'loading' | 'visible';

export const v2MigrationInitFlowStatusAtom = atom<V2MigrationInitFlowStatus>('loading');
